package fyi.moko.hotpl.ui.map

import fyi.moko.hotpl.domain.model.GeoPoint

/** Fallback camera target when there is no place/location to center on (Seoul). */
object MapDefaults {
    val FALLBACK_TARGET = GeoPoint(37.5665, 126.9780)
    const val DEFAULT_ZOOM: Float = 12f
}